import * as React from 'react';
import ImageData from './IHN0101-imgdetail';
import TablePagination from './IHN0101-imgpagination';

const IHN0101_ImgTable = (props) => {
    if (props === null) { return ""; }
    const isMobile = props.isMobile;
    const startIndex = (props.pageNo - 1) * props.sizePerPage;
    const endIndex = Math.min(Number(startIndex) + Number(props.sizePerPage), props.data.length);

    let datalist = props.data;

    if (datalist === null || datalist === undefined || datalist.length === 0) {
        datalist = [];
    }

    let dataOnPage = isMobile ? datalist : datalist.slice(startIndex, endIndex);
    
    return(
        <div className="img-table" style={{ marginTop: '15px', marginBottom: '15px' }}>
            <div className="row" >
                <TablePagination
                    translate={props.translate}
                    getTranslateValue={props.getTranslateValue}
                    totalItems={datalist.length}
                    sizePerPage={props.sizePerPage}
                    setSizePerPage={props.setSizePerPage}
                    pageNo={props.pageNo}
                    onPageChange={props.onPageChange}
                    length={datalist.length}
                    disabled={isMobile}
                />
            </div>
            <hr />
            <div className="row">
                {dataOnPage.map((item, index) => (
                        <ImageData 
                            key={index} 
                            data={item}
                            getImageDataUrl={props.getImageDataUrl}
                            handleQuantity={props.handleQuantity} 
                            translate={props.translate}
                            getTranslateValue={props.getTranslateValue} 
                            isRegular={props.isRegular}
                            controlKbn14={props.controlKbn14}
                            downloadPDF={props.downloadPDF}
                            handleAddToCart={props.handleAddToCart}
                        />
                ))}
            </div>
            <div className="row" >
                <TablePagination
                    translate={props.translate}
                    getTranslateValue={props.getTranslateValue}
                    totalItems={datalist.length}
                    sizePerPage={props.sizePerPage}
                    setSizePerPage={props.setSizePerPage}
                    pageNo={props.pageNo}
                    onPageChange={props.onPageChange}
                    length={datalist.length}
                    disabled={isMobile}
                />
            </div>
        </div>
    )
}

export default IHN0101_ImgTable;


// WEBPACK FOOTER //
// ./view/IHN0101/IHN0101-imgtable.jsx